import { ZERO } from "../constants";
const MAX_LENGTH = 20;
const START_LENGTH = 10;
const END_LENGTH = -6;
const ELLIPSIS = "....";

const formattedFileName = (fileName) => {
  if (fileName.length <= MAX_LENGTH) return fileName;

  const updatedFileName =
    fileName.substring(ZERO, START_LENGTH) +
    ELLIPSIS +
    fileName.slice(END_LENGTH);

  return updatedFileName;
};

export default formattedFileName;
